import { render, staticRenderFns } from "./IconDevices.vue?vue&type=template&id=50620550"
import script from "./IconDevices.vue?vue&type=script&lang=js"
export * from "./IconDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports